export default "__VITE_ASSET__Bw$yp1T3__"